import defaultStateConfig from './../../default.state.config';

export default {
  clearConfig (state) {
    state = Object.assign(state, defaultStateConfig);
  },
  setConfig (state, retrievedConfig) {
    state = Object.assign(state, retrievedConfig);
  },
  setReservationsStatus (state, newStatus) {
    state.company.status = newStatus;
  },
  setRuleBehavior (state, newStatus) {
    state.company.rule_behavior = newStatus;
  },
  setCompanyConfig (state, newSetting) {
    state.company[newSetting.field] = newSetting.value;
  },
  setCompanyRodoConfig (state, newSettings) {
    state.rodo = Object.assign({}, state.rodo, newSettings);
  },
  setCompanyInvoiceConfig (state, newSettings) {
    state.fakturownia = Object.assign({}, state.fakturownia, newSettings);
  },
  setCompanyPartialConfig (state, newSettings) {
    state.company = Object.assign({}, state.company, newSettings);
  },
  setGoogleCalendarConfig (state, newSettings) {
    state.company.google_calendar_recurring_items = newSettings.recurringItems;
    state.user.google_calendar_id = newSettings.googleCalendarId;
    state.company.google_calendar_twoway = newSettings.googleCalendarTwoWay;
  },
  setOutlookCalendarConfig (state, newSettings) {
    state.user.outlook_calendar_id = newSettings.outlookCalendarId;
    state.company.outlook_calendar_twoway = newSettings.outlookCalendarTwoWay;
  },
  setGetResponseConfig (state, newSettings) {
    newSettings = JSON.parse(JSON.stringify(newSettings));
    state.company.getresponse_apikey = newSettings.getresponse_apikey;
    state.company.getresponse_integration_type = newSettings.getresponse_integration_type;
    state.company.getresponse_unsubscribe = newSettings.getresponse_unsubscribe;
  },
  refreshConfig (state, newConfig) {
    state.user = Object.assign({}, state.user, newConfig.user);
    state.company = Object.assign({}, state.company, newConfig.company);
  },
  removeCompanyLogo (state) {
    state.company.logo = '';
    state.company.logo_url = '';
  },
  setTimeIncreaser (state, value) {
    state.company.time_increaser = value;
  },
  removeGoogleCalendarConfig (state) {
    state.user.google_calendar_id = '';
    state.user.google_email = '';
  },
  removeOutlookCalendarConfig (state) {
    state.user.outlook_calendar_id = '';
    state.user.outlook_email = '';
  }
}



// WEBPACK FOOTER //
// ./src/store/helpers/config/mutations.js